import { useEffect, useRef, useState } from 'react';

export const DEFAULT_HEADER_HEIGHTS = {
  desktop: 162,
  mobile: 70,
};

export interface DefaultHeaderHeightsProps {
  desktop: number;
  mobile: number;
}

interface UseHeaderAndFooterHeightProps {
  isMobileOrTablet: boolean;
  defaultHeaderHeights: DefaultHeaderHeightsProps;
}

export const useHeaderAndFooterHeight = ({
  isMobileOrTablet,
  defaultHeaderHeights,
}: UseHeaderAndFooterHeightProps) => {
  const [headerAndFooterHeight, setHeaderAndFooterHeight] = useState({
    header: isMobileOrTablet ? defaultHeaderHeights.mobile : defaultHeaderHeights.desktop,
    footer: 0,
  });
  const headerRef = useRef<HTMLDivElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHeaderAndFooterHeight({
      header: headerRef.current?.getBoundingClientRect().height ?? 0,
      footer: footerRef.current?.getBoundingClientRect().height ?? 0,
    });
  }, []);
  return {
    heights: headerAndFooterHeight,
    refs: { headerRef, footerRef },
  };
};
